import { render, staticRenderFns } from "./UserMescanMetabolism.vue?vue&type=template&id=c06be618&scoped=true"
import script from "./UserMescanMetabolism.vue?vue&type=script&lang=js"
export * from "./UserMescanMetabolism.vue?vue&type=script&lang=js"
import style0 from "./UserMescanMetabolism.vue?vue&type=style&index=0&id=c06be618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06be618",
  null
  
)

export default component.exports